export default __webpack_public_path__ + "7d69c54.png";